import Layout from '@/layout/index.vue';
export default [
  {
    // 商品
    path: '/productManage',
    component: Layout,
    hidden: true,
    redirect: 'noredirect',
    children: [
      {
        path: 'addProduct',
        component: () => import('@/views/productManage/productArchive/addProduct.vue'),
        name: 'AddProduct',
        meta: { title: '新增商品', icon: 'role', noCache: true },
      },
      {
        path: 'addFrontClass',
        component: () => import('@/views/productManage/productArchive/addFrontClass.vue'),
        name: 'AddFrontClass',
        meta: { title: '新增前台分类', icon: 'role', noCache: true },
      },
      {
        path: 'shopProductSynch',
        component: () => import('@/views/productManage/productSynch/shopProductSynch.vue'),
        name: 'ShopProductSynch',
        meta: { title: '商品同步', icon: 'role', noCache: true },
      },
      {
        path: 'synchDrtails',
        component: () => import('@/views/productManage/productSynch/synchDrtails.vue'),
        name: 'SynchDrtails',
        meta: { title: '同步详情', icon: 'role', noCache: true },
      },
    ],
  },
];
